<template>
    <div class="rounded-lg border overflow-hidden"
        :class="[
            is_open
                ? (dark ? 'border-gray-400 shadow-lg' : 'border-gray-400 shadow-md')
                : (dark ? 'border-gray-500' : 'border-gray-300'),
            dark ? 'bg-gray-600' : 'bg-white'
        ]"
    >
        <div class="relative cursor-pointer text-center relative pl-5 pr-4 py-4"
            :class="is_open
                ? (dark ? 'bg-blue-500 hover:bg-blue-600' : 'bg-blue-100 hover:bg-blue-200')
                : (dark ? 'bg-transparent hover:bg-blue-500' : 'bg-transparent hover:bg-blue-100')
            "
            @click="toggleOpen"
        >
            <div class="deal-wrap relative">
                <div class="flex items-center text-left select-none">
                    <div class="flex-1 text-base tracking-relaxed leading-normal">
                        <slot name="heading"></slot>
                    </div>

                    <div class="w-12 flex flex-none items-center justify-end">
                        <div class="transition-all"
                            :class="is_open
                                ? (dark ? 'rotate-45 text-blue-300' : 'rotate-45 text-blue-600')
                                : (dark ? 'rotate-0 text-gray-300' : 'rotate-0 text-gray-500')
                            "
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-show-slide:150:ease-in-out="is_open"
            @slide-open-end="slideOpenEnd"
        >
            <div class="p-5 border-t border-gray-400">
                <div class="text-base text-left leading-normal"
                    :class="dark ? 'text-gray-200' : 'text-gray-700'"
                >
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        closed: { default: true },
        dark: { default: false },
        name: {},
        url: {},
    },

    data() {
        return {
            is_open: ! this.closed,
        }
    },

    methods: {
        toggleOpen() {
            this.is_open = ! this.is_open;
        },
        slideOpenEnd() {
           //
        },
    },
}
</script>
